import styled from 'styled-components'
import splash_primary from 'src/assets/images/splash/splash_primary.png'
import logo from 'src/assets/images/logo/logo.png'
import { Container } from 'src/components/common/Container'

const SplashPageView = () => {
  return (
    <S.SplashContainer $option="flex_column_space_between">
      <S.PrimaryContents $option="flex_row">
        <S.PrimaryImg src={splash_primary} alt="메인 이미지" />
      </S.PrimaryContents>
      <S.LogoImg src={logo} alt="로고 이미지" />
    </S.SplashContainer>
  )
}
export default SplashPageView

const S = {
  SplashContainer: styled(Container)`
    flex: 1;
  `,
  PrimaryContents: styled(Container)`
    flex: 1;
    align-items: center;
  `,
  PrimaryImg: styled.img`
    width: 320px;
    height: 301px;
    margin: 0 auto;
  `,
  LogoImg: styled.img`
    margin: 50px auto;
    width: 156px;
    height: 23px;
  `,
}
